import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Link, useParams } from "react-router-dom";
import blogDetailsArray from "../../blogData.js";

const BlogDetailsHeroArea = () => {
  const [blogDetails, setBlogDetails] = useState([]);
  const { id } = useParams();

  useEffect(() => {
    setBlogDetails(blogDetailsArray);
  }, []);

  const findBlogDetails =
    blogDetails && blogDetails.find((blogItem) => blogItem.id === parseInt(id));

  return (
    <Wrapper>
      <div className="breadcumb-area d-flex align-items-center">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-12">
              <div className="breacumb-content">
                <div className="breadcum-title">
                  <h4 className="fs-1 mb-0">Blog Details</h4>
                  <h4 className="mt-0">
                    {findBlogDetails && findBlogDetails.title}
                  </h4>
                </div>
                <ul>
                  <li>
                    <Link to="/">Home</Link>
                  </li>
                  <li>&nbsp;/&nbsp;</li>
                  <li>Blog Details</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Wrapper>
  );
};

const Wrapper = styled.section`
  .breadcumb-area {
    padding: 170px 0 120px;
  }
`;

export default BlogDetailsHeroArea;
